import { render, staticRenderFns } from "./sdproduct7.vue?vue&type=template&id=89c86c2c&scoped=true"
import script from "./sdproduct7.vue?vue&type=script&lang=js"
export * from "./sdproduct7.vue?vue&type=script&lang=js"
import style0 from "./sdproduct7.vue?vue&type=style&index=0&id=89c86c2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c86c2c",
  null
  
)

export default component.exports